import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '../button'
import { useHistory, useParams } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { findProductQuery, updateProductQuery } from '../../queries'
import { FindProduct } from '../../queries/types/FindProduct'
import { UpdateProduct, UpdateProductVariables } from '../../queries/types/UpdateProduct'
import { Field, FormCard, PageHeader, inputClassName } from '../ui'

export function ProductEdit(): JSX.Element {
    const {t} = useTranslation()
    const history = useHistory()
    const { id: productID } = useParams<{id: string}>()
    const [title, setTitle] = useState('')
    const [mmk, setMMK] = useState('')
    const [usd, setUSD] = useState('')

    const { data: productData } = useQuery<FindProduct>(findProductQuery, {
        fetchPolicy: 'cache-and-network',
        variables: {
            id: productID
        }
    })
    const [ updateProduct ] = useMutation<UpdateProduct, UpdateProductVariables>(updateProductQuery)

    function updateThenGo() {
        updateProduct({
            variables: {
                id: productID,
                title: title,
                MMK: mmk != '' ? Number(mmk) : undefined,
                USD: usd != '' ? Number(usd) : undefined,
            }
        }).then(() => {
            history.push('/products')
        })
    }

    useEffect(() => {
        if (productData && productData.findProduct) {
            setTitle(productData.findProduct.title)
            setMMK(productData.findProduct.priceList.MMK ? `${productData.findProduct.priceList.MMK}` : '')
            setUSD(productData.findProduct.priceList.USD ? `${productData.findProduct.priceList.USD}` : '')
        }
    }, [productData])

    return (
        <>
            <PageHeader title={t('products-create.title')} />
            <FormCard>
                <Field label={t('products-create.form.label.title')}>
                    <input name='title' value={title} onChange={(e) => setTitle(e.target.value)} className={inputClassName} placeholder={t('products-create.form.placeholder.title')} />
                </Field>
                <Field label={t('products-create.form.label.priceMMK')}>
                    <input name='mmk' value={mmk} onChange={(e) => setMMK(e.target.value)} className={inputClassName} placeholder='1000' />
                </Field>
                <Field label={t('products-create.form.label.priceUSD')}>
                    <input name='usd' value={usd} onChange={(e) => setUSD(e.target.value)} className={inputClassName} placeholder='1' />
                </Field>
                <div className='mt-6 flex justify-end'>
                    <PrimaryButton onClick={() => updateThenGo()} type='submit'>{t('shared.button.label.submit')}</PrimaryButton>
                </div>
            </FormCard>
        </>)
}
